import React, { useMemo } from "react";
import Typography from "@common/components/Typography";
import { SxProps, Theme, TypographyProps, Tooltip } from "@mui/material";

type ListTypographyProps = TypographyProps & {
  cellValue?: string | boolean | number;
  realTime?: boolean;
  tooltip?: string;
  truncate?: boolean;
  maxLines?: number;
};

const ListTypography = (props: ListTypographyProps) => {
  const {
    cellValue,
    realTime = false,
    sx,
    tooltip,
    truncate = true,
    maxLines = 1,
    ...other
  } = props;

  const truncateTextStyle: SxProps<Theme> = {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-all",
    WebkitLineClamp: maxLines,
  };
  const styling = useMemo(
    (): SxProps<Theme> => [
      { fontFamily: realTime ? "Realtime" : "Rubik" },
      Boolean(cellValue) && cellValue !== "-"
        ? {}
        : ({ palette }) => ({ color: palette.common.grey.dark }),
      truncate ? truncateTextStyle : {},
      ...(Array.isArray(sx) ? sx : [sx]),
    ],
    [realTime, sx, cellValue, truncate]
  );

  return (
    <Tooltip arrow title={tooltip ?? ""}>
      <Typography sx={styling} {...other}>
        {Boolean(cellValue) ? cellValue : "-"}
      </Typography>
    </Tooltip>
  );
};

export default ListTypography;
